import { action, makeObservable, observable } from 'mobx';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { Employee } from 'nomst/Stores/Decision/employee';
import { ICompMemoStore } from 'typings/compMemo';
import { dataManagerFactory } from 'utils/MobxDataManager/singletons';

export default class CompMemoStore implements ICompMemoStore {
    @observable employeeCompData: Nullable<Employee>;

    readonly configuration: Configuration;

    constructor(configuration: Configuration) {
        makeObservable(this);
        this.employeeCompData = null;
        this.configuration = configuration;
    }

    @action
    resetData(): void {
        this.employeeCompData = null;
    }

    @action
    async getEmployeeCompMemoData(employeeSourceId: string): Promise<void> {
        this.employeeCompData = null;
        const managerDataManager = dataManagerFactory.getManagerDataManager();
        if (!managerDataManager || !this.configuration || !employeeSourceId?.length) {
            return;
        }
        
        const employeesDto = await managerDataManager.getEmployeeCompMemoData(
            this.configuration.masterAccountId,
            this.configuration.cycleId,
            employeeSourceId);
        this.employeeCompData = employeesDto &&
                new Employee(employeesDto, employeesDto.annualStandardWorkHours ?? 2080, null, this.configuration, null, null);
    }
}
